import React from 'react';
import Button from 'common/components/button/Button';
import styles from './TablePagination.module.scss';

interface Props {
    // zero-based current page
    page: number;
    totalPages: number;
    onChange: (page: number) => void;
    previousLabel: string;
    nextLabel: string;
    // already-formatted "Page X of Y" text
    info: string;
    firstTitle?: string;
    lastTitle?: string;
}

const TablePagination: React.FC<Props> = ({
    page, totalPages, onChange, previousLabel, nextLabel, info, firstTitle, lastTitle,
}) => {
    const isFirst = page <= 0;
    const isLast = page >= totalPages - 1;

    return (
        <div className={styles.pagination}>
            <Button variant="secondary" size="small" disabled={isFirst} onClick={() => onChange(0)} title={firstTitle}>
                {'«'}
            </Button>
            <Button variant="secondary" size="small" disabled={isFirst} onClick={() => onChange(page - 1)}>
                {previousLabel}
            </Button>
            <span className={styles.pageInfo}>{info}</span>
            <Button variant="secondary" size="small" disabled={isLast} onClick={() => onChange(page + 1)}>
                {nextLabel}
            </Button>
            <Button variant="secondary" size="small" disabled={isLast} onClick={() => onChange(totalPages - 1)} title={lastTitle}>
                {'»'}
            </Button>
        </div>
    );
};

export default TablePagination;
